export const CENTRIX_SSO_CONTAINER_TAG_NAME = 'centrix-sso-container';
